// Wipe tenant-specific local data — called on logout and on login when the
// authenticated user's tenant_id differs from the cached one. Prevents the
// classic multi-tenant SPA bug where Tenant A's menu items leak into
// Tenant B's POS via the persistent IndexedDB cache.

import { db } from './index';

export async function resetTenantLocalData(): Promise<void> {
  await db.transaction(
    'rw',
    [db.menu_categories, db.menu_items, db.orders, db.order_items,
     db.payments, db.pending_ops, db.conflicts, db.settings],
    async () => {
      await db.menu_categories.clear();
      await db.menu_items.clear();
      await db.orders.clear();
      await db.order_items.clear();
      await db.payments.clear();
      await db.pending_ops.clear();
      await db.conflicts.clear();
      // Keep settings.theme_mode etc. — wipe only POS-tied keys.
      const drop = ['branch_id', 'currency', 'device_id', 'device_prefix', 'last_pull_at'];
      for (const key of drop) await db.settings.delete(key);
    },
  );
}
